// extracted by mini-css-extract-plugin
module.exports = {"wiz4sox":"wiz4sox","s1fv5i8n":"s1fv5i8n","s129kf5y":"s129kf5y","p1aiwiva":"p1aiwiva"};